module.exports = require("@babel/runtime/helpers/extends");